import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import { useUserStore } from "./store/userStore";
import { userApi } from "./apiServices/UserApiService";

const api = axios.create({
  // baseURL: "https://localhost:7131"
  // ,
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

let isRefreshing = false;
let waiters: Array<(token: string | null) => void> = [];

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const t = useUserStore.getState().accessToken;
  if (t) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error: AxiosError) => {
    const original = error.config as any;
    if (error.response?.status !== 401 || original?._retry) {
      return Promise.reject(error);
    }
    original._retry = true;

    const store = useUserStore.getState();
    const refreshToken = store.refreshToken;
    let email = store.user?.emailId;

    if (!refreshToken) {
      useUserStore.getState().logout();
      return Promise.reject(error);
    }

    // Try to derive email from JWT if not stored in user
    if (!email) email = store.peekDecoded()?.email ?? undefined;
    if (!email) {
      useUserStore.getState().logout();
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        waiters.push((newAccess) => {
          if (!newAccess) return reject(error);
          original.headers = original.headers ?? {};
          original.headers.Authorization = `Bearer ${newAccess}`;
          resolve(api(original));
        });
      });
    }

    try {
      isRefreshing = true;
      const res = await userApi.refresh({ email, refreshToken });
      useUserStore.getState().setTokens(res.token, res.refreshToken);

      waiters.forEach((w) => w(res.token));
      waiters = [];

      original.headers = original.headers ?? {};
      original.headers.Authorization = `Bearer ${res.token}`;
      return api(original);
    } catch (e) {
      waiters.forEach((w) => w(null));
      waiters = [];
      useUserStore.getState().logout();
      return Promise.reject(e);
    } finally {
      isRefreshing = false;
    }
  }
);

export default api;
